<div [formGroup]="zone5Form">
  <div class='container'>
    <div class="card">
      <div class="card-body">
        <h2 class="card-title btn-ouline-success-title">Zone n°5</h2>
        <div class="row">
          <div class='col-12'>
            <label class="form-label" >Type de pose <span class="required">*</span></label>
            <div class="btn-group d-block" role="group">
              <ng-container *ngFor="let typePose of typePoses">
                <input type="radio" formControlName="typePoseZone5" class="btn-check btn-type-pose-options" [value]="typePose.code" [id]="typePose.code + 5"
                       (change)='onRadioClickZone5(typePose.code, "typePoseZone5")' tabindex="1">
                <label class="btn btn-outline-success btn-type-pose-options" [for]="typePose.code + 5"> {{ typePose.label }}</label>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="zone5Form.get('typePoseZone5').value === 'TOITURE'">
      <div class="card-body">
        <h2 class="card-title">Toiture</h2>
        <div class="row">
          <div class="col-5">
            <label class="form-label" for="typeToitureZone5">Type toiture <span class="required">*</span></label>
            <select class="form-select" id="typeToitureZone5" formControlName="typeToitureZone5" tabindex="10"
                    [ngClass]="zone5Form.get('typeToitureZone5').invalid && (zone5Form.get('typeToitureZone5').dirty || zone5Form.get('typeToitureZone5').touched) ? 'is-invalid' : ''">
              <option value=""></option>
              <option *ngFor="let typeToitureZone5 of typeToitures" [ngValue]="typeToitureZone5.code"
                      [selected]="zone5Form.get('typeToitureZone5').value && typeToitureZone5.code === zone5Form.get('typeToitureZone5').value">
                {{ typeToitureZone5.label }}
              </option>
            </select>
            <div class="invalid-feedback">
              <div *ngIf="zone5Form.get('typeToitureZone5').errors?.['required']">Le type de toiture est obligatoire</div>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group form-check">
              <span class="spanCheckbox">PV Ready <span class="required">*</span></span>
              <input class="form-check-input" type="checkbox" formControlName="pvReadyZone5" tabindex="11"
                     [ngClass]="zone5Form.get('pvReadyZone5').invalid && (zone5Form.get('pvReadyZone5').dirty || zone5Form.get('pvReadyZone5').touched) ? 'is-invalid' : ''">
              <div class="invalid-feedback">
                <div *ngIf="zone5Form.get('pvReadyZone5').errors?.['required']">Cocher PV Ready</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <label for="inclinaisonZone5" class="form-label">Inclinaison <span class="required">*</span></label>
              <div class="col-10">
                <input type="number" class="form-control" id="inclinaisonZone5" formControlName="inclinaisonZone5" placeholder="Ex : 100" tabindex="12"
                       [ngClass]="zone5Form.get('inclinaisonZone5').invalid && (zone5Form.get('inclinaisonZone5').dirty || zone5Form.get('inclinaisonZone5').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone5Form.get('inclinaisonZone5').errors?.['pattern']">L'inclinaison n'est pas valide</div>
                  <div *ngIf="zone5Form.get('inclinaisonZone5').errors?.['required']">L'inclinaison est obligatoire</div>
                  <div *ngIf="zone5Form.get('inclinaisonZone5').errors?.['inclinaisonMax']">
                    L'inclinaison doit être comprise entre 0 et 3°
                  </div>

                  <div *ngIf="zone5Form.get('inclinaisonZone5').errors?.['inclinaisonMin']">
                    L'inclinaison doit être supérieure à 3°
                  </div>
                </div>
              </div>
              <div class="col-1">
                <span class="spanTextMiddle">°</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="zone5Form.get('typeToitureZone5').value === 'BETON' || zone5Form.get('typeToitureZone5').value === 'TAN_ETANCHE'">
          <div class="col-12">
            <label class="form-label">Orientation</label>
            <div class="btn-group d-block" role="group">
              <input type="radio" formControlName="orientationTerrasseZone5" class="btn-check btn-type-pose-options" value="SUD" id="orientationSudZone5" tabindex="13">
              <label class="btn btn-outline-success btn-type-pose-options" for="orientationSudZone5">SUD</label>
              <input type="radio" formControlName="orientationTerrasseZone5" class="btn-check btn-type-pose-options" value="EST_OUEST" id="orientationEstOuestZone5" tabindex="14">
              <label class="btn btn-outline-success btn-type-pose-options" for="orientationEstOuestZone5">EST/OUEST</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="zone5Form.get('typePoseZone5').value === 'OMBRIERE'">
      <div class="card-body">
        <h2 class="card-title">Ombrière</h2>
          <div class="vehicule-options">
            <img
              src="../../../../assets/images/img/pl.png"
              alt="Poids Lourd"
              class="vehicule-img"
              [class.selected]="zone5Form.get('typeVehiculeParkingZone5')?.value === 'PL'"
              (click)="selectVehicule('PL', null)"
            />
          
            <img
              src="../../../../assets/images/img/vl_place_1.png"
              alt="VL Place 1"
              class="vehicule-img"
              [class.selected]="isVLSelected('PLACE_1')"
              (click)="selectVehicule('VL', 'PLACE_1')"
            />
          
            <img
              src="../../../../assets/images/img/vl_place_2.png"
              alt="VL Place 2"
              class="vehicule-img"
              [class.selected]="isVLSelected('PLACE_2')"
              (click)="selectVehicule('VL', 'PLACE_2')"
            />
          
            <img
              src="../../../../assets/images/img/vl_portique.png"
              alt="VL Portique"
              class="vehicule-img"
              [class.selected]="isVLSelected('PORTIQUE')"
              (click)="selectVehicule('VL', 'PORTIQUE')"
            />
          
            <img
              src="../../../../assets/images/img/vl_place_1_bois.png"
              alt="VL Place 1 Bois"
              class="vehicule-img"
              [class.selected]="isVLSelected('PLACE_1_BOIS')"
              (click)="selectVehicule('VL', 'PLACE_1_BOIS')"
            />
          
            <img
              src="../../../../assets/images/img/vl_place_2_bois.png"
              alt="VL Place 2 Bois"
              class="vehicule-img"
              [class.selected]="isVLSelected('PLACE_2_BOIS')"
              (click)="selectVehicule('VL', 'PLACE_2_BOIS')"
            />

            <img
              src="../../../../assets/images/img/est_ouest.png"
              alt="VL Est Ouest"
              class="vehicule-img"
              [class.selected]="isVLSelected('EST_OUEST')"
              (click)="selectVehicule('VL', 'EST_OUEST')"
            />
          </div>
        <div
          class="error-message"
          *ngIf="
            zone5Form.get('typeVehiculeParkingZone5')?.invalid &&
            zone5Form.get('typeVehiculeParkingZone5')?.touched
          "
        >
          Le type de véhicule sur le parking est obligatoire
        </div>
      </div>
    </div>

    <div class="card" *ngIf="zone5Form.get('typePoseZone5').value">
      <div class="card-body">
        <div class="row">
          <div class='col-12'>
            <label for="surfaceZone5" class="form-label">Surface <span class="required">*</span></label>
            <div class="row">
              <div class="col-10">
                <input type="number" class="form-control" id="surfaceZone5" formControlName="surfaceZone5" placeholder="Ex : 45.32" tabindex="8"
                   [attr.disabled]="true"
                   [ngClass]="zone5Form.get('surfaceZone5').invalid && (zone5Form.get('surfaceZone5').dirty || zone5Form.get('surfaceZone5').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone5Form.get('surfaceZone5').errors?.['required']">La surface est obligatoire</div>
                  <div *ngIf="zone5Form.get('surfaceZone5').errors?.['pattern']">La surface n'est pas valide</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">m²</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-12'>
            <label for="puissanceChoisieZone5" class="form-label">Puissance choisie</label>
            <div class="row">
              <div class="col-10">
                <input
                  type="number"
                  class="form-control"
                  id="puissanceChoisieZone5"
                  formControlName="puissanceChoisieZone5"
                  (focus)="onPuissanceChoisieFocus($event)"
                  [ngClass]="(zone5Form.get('puissanceChoisieZone5').invalid && (zone5Form.get('puissanceChoisieZone5').dirty || zone5Form.get('puissanceChoisieZone5').touched)) || (zone5Form.errors?.['surfaceOrPowerRequired'] && zone5Form.get('typePoseZone5').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone5Form.get('puissanceChoisieZone5').errors?.['pattern']">La puissance choisie n'est pas valide</div>
                  <div *ngIf="zone5Form.errors?.['surfaceOrPowerRequired']">La surface ou la puissance choisie est obligatoire</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">kWc</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-12'>
            <label for="azimutZone5" class="form-label">{{ azimutLabel }} <span class="required">*</span></label>
            <div class="row">
              <div class="col-10">
                <input type="number" class="form-control" id="azimutZone5" formControlName="azimutZone5" placeholder="Ex : 100" tabindex="9"
                 [attr.disabled]="true"
                 [ngClass]="zone5Form.get('azimutZone5').invalid && (zone5Form.get('azimutZone5').dirty || zone5Form.get('azimutZone5').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone5Form.get('azimutZone5').errors?.['required']">L'azimut est obligatoire</div>
                  <div *ngIf="zone5Form.get('azimutZone5').errors?.['pattern']">L'azimut n'est pas valide</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">°</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

